<template>
  <div class="content">
    <!-- Header -->
    <SectionHeading
      :title="userView ? $t('Назначенные права') : $t('Настройка прав')"
      :description="
        !userView ? $t('Выберите необходимые права для данной роли') : ''
      "
      title-class="text-xl"
    />
    <div class="w-full flex flex-col gap-4">
      <div
        v-for="group in filteredGroups"
        :key="group.title"
        class="rounded-xl flex flex-col"
      >
        <div class="gray-block" @click="toggleExpand(group)">
          <Checkbox
            v-model="group.selected"
            @change="toggleGroup(group)"
            @click.stop
          >
            <span class="font-medium text-base text-gray-700">
              {{ group.title }}
            </span>
          </Checkbox>
          <svg-icon
            :name="group.isExpanded ? 'huge-up' : 'huge-down'"
            class="icon"
          />
        </div>
        <transition name="slide-fade">
          <div v-show="group.isExpanded" class="flex flex-col pl-8 gap-2">
            <div
              v-for="child in group.children"
              :key="child.label"
              class="flex items-center self-stretch p-0"
            >
              <Checkbox v-model="child.checked" @change="onChildChange(group)">
                {{ $t(child.label) }}
              </Checkbox>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "@/shared/ui/checkbox/Checkbox.vue";
import { SectionHeading } from "@/shared/ui/section-heading";

export default {
  name: "OrganizationAssignedData",
  components: { Checkbox, SectionHeading },
  data() {
    return {
      search: "",
      groups: [
        {
          title: "Модуль 1",
          selected: true,
          isExpanded: true,
          children: [
            { label: "Просмотр", checked: true },
            { label: "Редактирование", checked: true },
            { label: "Экспорт", checked: true },
            { label: "Просмотр истории", checked: false },
          ],
        },
        {
          title: "Модуль 2",
          selected: true,
          isExpanded: true,
          children: [
            { label: "Просмотр", checked: true },
            { label: "Редактирование", checked: true },
            { label: "Экспорт", checked: true },
            { label: "Просмотр истории", checked: false },
          ],
        },
        {
          title: "Модуль 3",
          selected: true,
          isExpanded: true,
          children: [
            { label: "Просмотр", checked: true },
            { label: "Редактирование", checked: true },
            { label: "Экспорт", checked: true },
            { label: "Просмотр истории", checked: false },
          ],
        },
      ],
    };
  },
  computed: {
    userView() {
      return this.$route.name === "user_item_view";
    },
    filteredGroups() {
      if (!this.search) return this.groups;
      const s = this.search.toLowerCase();
      return this.groups.map((g) => ({
        ...g,
        children: g.children.filter((c) => c.label.toLowerCase().includes(s)),
      }));
    },
  },
  methods: {
    toggleExpand(group) {
      group.isExpanded = !group.isExpanded;
    },
    toggleGroup(group) {
      group.children.forEach((child) => {
        child.checked = group.selected;
      });
    },
    onChildChange(group) {
      group.selected = group.children.every((c) => c.checked);
    },
    validate() {
      return Promise.resolve(true);
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  @apply h-full flex flex-col p-8 gap-6 overflow-auto bg-white rounded-2xl;
}
.gray-block {
  @apply w-full flex items-center mb-3 px-4 py-2 gap-3 self-stretch bg-gray-50 rounded-xl;
  @apply cursor-pointer hover:bg-gray-100 transition-colors;

  .icon {
    @apply w-6 h-6 ml-auto text-gray-500 transition-transform duration-200 flex-shrink-0;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
